import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "alert alert-danger mb-4"
}
const _hoisted_2 = { class: "item-info" }
const _hoisted_3 = { class: "item-info" }
const _hoisted_4 = { class: "item-info" }
const _hoisted_5 = { class: "item-info" }
const _hoisted_6 = { class: "item-info" }
const _hoisted_7 = { class: "item-info" }
const _hoisted_8 = { class: "item-info" }


    import { formatAmount } from '@/utils';
    import { computed, reactive, ref } from 'vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'OnboardingGroupeItemDetailsModal',
  setup(__props, { expose: __expose }) {

    // @ts-expect-error raison: lib externe mal typée
    let admin: any = null;
    const isOpened = ref(false);
    const errorMessage = ref('');
    const loading = ref(false);
    const itemInfos = reactive({
        nom: '',
        prenom: '',
        date_naissance: '',
        telephone: '',
        email: '',
        salaire: 0,
        quotite_cessible_montant: 0,
        quotite_cessible_pourcent: 0
    });
    const itemErrors = ref<any>({});
    
    async function open(dataRow: any) {
        Object.assign(itemInfos, dataRow.data);
        itemErrors.value = dataRow.errors || {};
        isOpened.value = true;
    }

    function close() {
        isOpened.value = false;
    }

    const errorsText = computed(() => {
        return Object.values(itemErrors.value).flat().join(' ');
    });

    __expose({ open, close });

return (_ctx: any,_cache: any) => {
  const _component_custom_modal = _resolveComponent("custom-modal")!

  return (_openBlock(), _createBlock(_component_custom_modal, {
    show: isOpened.value,
    "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((isOpened).value = $event))
  }, {
    header: _withCtx(() => [...(_cache[2] || (_cache[2] = [
      _createElementVNode("h4", { class: "font-semibold" }, "Informations compte", -1)
    ]))]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        class: "btn-ultra white2",
        style: {"justify-content":"center"},
        onClick: _cache[0] || (_cache[0] = ($event: any) => (isOpened.value = false))
      }, "Fermer")
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        (errorsText.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(errorsText.value), 1))
          : _createCommentVNode("", true),
        _cache[10] || (_cache[10] = _createElementVNode("h5", { class: "flex align-items-center gap-4 font-medium text-primary-color my-5" }, [
          _createElementVNode("img", {
            src: "/icons/icon-info-perso.svg",
            class: "size-base",
            alt: ""
          }),
          _createTextVNode(" Informations personnelles ")
        ], -1)),
        _createElementVNode("div", {
          class: _normalizeClass(["item-row", { error: itemErrors.value.nom }])
        }, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "label" }, "Nom", -1)),
          _createElementVNode("div", _hoisted_2, _toDisplayString(itemInfos.nom || '-'), 1)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["item-row", { error: itemErrors.value.prenom }])
        }, [
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "label" }, "Prénoms", -1)),
          _createElementVNode("div", _hoisted_3, _toDisplayString(itemInfos.prenom || '-'), 1)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["item-row", { error: itemErrors.value.date_naissance }])
        }, [
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "label" }, "Date naissance", -1)),
          _createElementVNode("div", _hoisted_4, _toDisplayString(itemInfos.date_naissance || '-'), 1)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["item-row", { error: itemErrors.value.telephone }])
        }, [
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "label" }, "Téléphone", -1)),
          _createElementVNode("div", _hoisted_5, _toDisplayString(itemInfos.telephone || '-'), 1)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["item-row", { error: itemErrors.value.email }])
        }, [
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "label" }, "Adresse Email", -1)),
          _createElementVNode("div", _hoisted_6, _toDisplayString(itemInfos.email || '-'), 1)
        ], 2),
        _cache[11] || (_cache[11] = _createElementVNode("h5", { class: "flex align-items-center gap-4 font-medium text-primary-color my-5" }, [
          _createElementVNode("img", {
            src: "/icons/icon-engagement.svg",
            class: "size-base",
            alt: ""
          }),
          _createTextVNode(" Engagement ")
        ], -1)),
        _createElementVNode("div", {
          class: _normalizeClass(["item-row", { error: itemErrors.value.salaire }])
        }, [
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "label" }, "Salaire brut", -1)),
          _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(formatAmount)(itemInfos.salaire)), 1)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["item-row", { error: itemErrors.value.quotite_cessible_montant || itemErrors.value.quotite_cessible_pourcent }])
        }, [
          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "label" }, "Quotité cessible", -1)),
          _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(formatAmount)(itemInfos.quotite_cessible_montant) + ' (' + itemInfos.quotite_cessible_pourcent + '%)'), 1)
        ], 2)
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})